export enum Workshift {
  Day = "Day",
  Evening = "Evening",
  Holiday = "Holiday",
  Night = "Night",
  OnCall = "OnCall",
  Weekend = "Weekend"
}
